<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M18.7003 24L10.667 15.9667L18.7003 7.93335L20.1337 9.36668L13.5337 15.9667L20.1337 22.5667L18.7003 24Z"
      :fill="color"
      fill-opacity="0.38"
    />
  </svg>
</template>

<script>
export default {
  name: 'NavPrevIcon',
  props: {
    color: {
      type: String,
      default: 'black'
    },
    size: {
      type: Number,
      default: 32
    }
  }
}
</script>
